import React from 'react'
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, IconButton, Chip
} from '@mui/material';
import { Deletes, Edit, PasswordLock } from '../../Svg';
const Operations = ({ viewClick, editClick, deleteClick, TableCells, selectedTab, showpass, passwordClick, hidedelete ,hideedit}) => {


  return (
    <TableCells sx={{ width: '10%' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div onClick={viewClick}>
          <IconButton aria-label="view" size="small" sx={{ padding: '4px' }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.99985 11.9997C10.6561 11.9997 11.9987 10.6571 11.9987 9.00082C11.9987 7.34459 10.6561 6.00195 8.99985 6.00195C7.34362 6.00195 6.00098 7.34459 6.00098 9.00082C6.00098 10.6571 7.34362 11.9997 8.99985 11.9997Z" fill="#858D9D" />
              <path d="M17.4501 7.06527C16.2873 5.17147 13.6423 1.99414 8.99998 1.99414C4.35771 1.99414 1.71269 5.17147 0.549868 7.06527C-0.183289 8.25111 -0.183289 9.74947 0.549868 10.9353C1.71269 12.8291 4.35771 16.0065 8.99998 16.0065C13.6423 16.0065 16.2873 12.8291 17.4501 10.9353C18.1833 9.74947 18.1833 8.25111 17.4501 7.06527ZM8.99998 13.4986C6.51564 13.4986 4.50165 11.4846 4.50165 9.00029C4.50165 6.51595 6.51564 4.50196 8.99998 4.50196C11.4843 4.50196 13.4983 6.51595 13.4983 9.00029C13.4958 11.4836 11.4833 13.4961 8.99998 13.4986Z" fill="#858D9D" />
            </svg>

          </IconButton>
        </div>
        {selectedTab !== 1 &&
          <div onClick={editClick}>
            <IconButton color="primary" aria-label="edit" size="small" sx={{ padding: '4px' }}>
              <Edit />
            </IconButton>
          </div>
        }
        {showpass === 'show' ?

          <div onClick={passwordClick}>
            <IconButton color="primary" aria-label="edit" size="small" sx={{ padding: '4px' }}>
              <PasswordLock />
            </IconButton>
          </div>
          : null}
        {hidedelete != 'hide' ? 
          <div>
            <IconButton color="secondary" aria-label="delete" onClick={deleteClick} size="small" sx={{ padding: '4px' }}>
              <Deletes />
            </IconButton>
          </div>
        :null}
      </div>
    </TableCells>
  )
}

export default Operations
